<template>
  <div class="mulu_box">
    <div v-for="(item,index) in listData" :key="index" class="firstmulu">
      <div :class="['firstmulu_li']">
        <span class="sanjiao" @click="handelShow(item)">
          <svg-icon v-if="!item.show" icon-class="sanjiao" />
          <svg-icon v-else icon-class="sanjiaoxia" />
        </span>
        <span class="dian" />
        <span class="mulu_name" @click="goread(item.CATALOG_ID)">{{ item.CATALOG_NAME }}</span>
        <span class="num"><svg-icon icon-class="wenjian" />{{ item.CONTENT_NUMBER }}</span>
      </div>
      <!--<div>{{item}}</div>-->
      <div v-if="item.show">
        <div v-if="item.CONTENT_DETAIL.length>0" class="zimulu">
          <div v-for="(item1,index2) in item.CONTENT_DETAIL" :key="index2" class="zimulu_li" @click="goread(item.CATALOG_ID,item1.CONTENT_ID)">
            <span class="zimulu_span"> {{ item1.CONTENT_TITLE }}</span>
            <!--<span class="num"><svg-icon icon-class="wenjian" />{{ item1.CATALOG_CONTENT_SIZE }}</span>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['list', 'albumId'],
  data() {
    return {
      showIndex: '',
      listData: []
    }
  },

  mounted() {
    var listData = JSON.parse(JSON.stringify(this.list))
    listData.forEach(a => {
      a.show = true
    })
    this.listData = listData
  },

  methods: {
    handelShow: function(item) {
      if (item.show) {
        item.show = false
      } else {
        item.show = true
      }
    },
    goread(id1, id2) {
      // console.log(this.albumId)
      this.$router.push({ path: '/albumDetailRead', query: { 'albumId': this.albumId, 'dirId': id1, 'contendId': id2 }})
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .mulu_box{
        padding-left: 28px;
        .firstmulu{
            /*padding: 10px 0;*/
            border-bottom: 1px dashed #e6e6e6;
            .firstmulu_li{
               height: 35px;
                line-height: 35px;
            }
            .active{
                background-color: #eae8e9;
            }
            .sanjiao{
                transition: 3s;
                color: #808080;
                cursor: pointer;
                &:hover{
                    color: #ed4040;
                }
            }
            .dian{
                display: inline-block;
                height: 5px;
                width: 5px;
                background-color: #59bd5b;
                margin-right: 7px;
                margin-left: 10px;
                vertical-align: middle;
            }
            .mulu_name{
                cursor: pointer;
                &:hover{
                    color: #ed4040;
                }
            }
            .num{
                    float: right;
                margin-right: 30px;
                color: #cdcdcd;
                width: 35px;
                text-align: right;
            }
            .zimulu{
                overflow: hidden;
                .zimulu_li{
                    height: 35px;
                    line-height: 35px;
                    padding-left: 35px;
                    border-top: 1px dashed #e6e6e6;
                    cursor: pointer;
                    &:hover{
                        background-color: #eae8e9;
                        color: #ed4040;
                    }
                    .zimulu_span{
                        font-size: 13px;
                        cursor: pointer;
                        &:hover{
                            color: #ed4040;
                        }
                    }
                }
            }
        }
    }
</style>
